var exports = {
  "kL": "xe564cbfb--0d253e--container",
  "bb": "xe564cbfb--0d253e--container--promo",
  "my": "xe564cbfb--0d253e--avatar",
  "UU": "xe564cbfb--0d253e--name",
  "G0": "xe564cbfb--0d253e--name--without-logo",
  "nf": "xe564cbfb--0d253e--link",
  "ix": "xe564cbfb--0d253e--name-block",
};

module.exports = exports;
